export const DR_BUTTON_TEXT = {
  ALL: 'key14',
  ENABLED: 'key15',
  DISABLED: 'key16',
};

export const SORT_TYPE = {
  DEVICE: "key19",
  CONS: "key20",
  CREATE: "key21"
}